import { render } from "./CartViewPayment.vue?vue&type=template&id=4a9fb874&scoped=true&ts=true"
import script from "./CartViewPayment.vue?vue&type=script&lang=ts"
export * from "./CartViewPayment.vue?vue&type=script&lang=ts"

import "./CartViewPayment.vue?vue&type=style&index=0&id=4a9fb874&lang=scss&scoped=true"

import exportComponent from "/Users/davidebertuzzi/WebstormProjects/procremonafrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9fb874"]])

export default __exports__